<template>
  <FormBody :number="3">
    <div class="container">
      <h3 class="feedback-types__title">Спасибо за обращение, ваша заявка была отправлена</h3>
      <p>Специалист страховой компании свяжется с Вами сразу после обработки заявки</p>
      <div class="image-wrap">
        <img src="../assets/mail.png" alt="mail">
      </div>
      <router-link :to="{name : 'home'}" class="button">Новое обращение</router-link>
    </div>
  </FormBody>
</template>

<script>
import FormBody from "@/components/utils/FormBody";

export default {
  anotherNameLife: "RequestSent",
  components: {
    FormBody
  }
}
</script>

<style scoped>
  .container{
    padding: 25px 50px;
    text-align: center;
  }

  .image-wrap{
    text-align: center;
  }
  img{
    width: 80%;
  }
  .button{
    display: block;
    width: 80%;
    background: #e20026;
    color: #fff;
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    border: none;
    cursor: pointer;
    line-height: 36px;
    margin: 0 auto;
    border-radius: 5px;
  }
</style>